import { Injectable } from '@angular/core';

import { ClientConfigProductName, ContentService } from '@frontend/vanilla/core';
import { BehaviorSubject } from 'rxjs';

import { DashboardContentPath } from '../toggle-navigation/model';

@Injectable({
    providedIn: 'root',
})
export class UserBannerService {
    rewardsHubState: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(private contentService: ContentService) {
        this.contentService.getJson(DashboardContentPath, { filterOnClient: false, product: ClientConfigProductName.PROMO }).subscribe((data) => {
            this.rewardsHubState.next(data);
        });
    }
}
